import { useEffect, useState } from 'react';
import { ClosePopUpIcon } from '../../assets/svgs/icons';
import CheckBox from '../common/Form/Checkbox';
import Modal from '../common/Modal';

export interface SelectableLocation {
  id: number;
  label: string;
}

interface SelectLocationsModalProps {
  isOpen: boolean;
  locations: SelectableLocation[];
  initialSelectedIDs?: number[];
  description?: string;
  onCancel: () => void;
  onSave: (selectedIDs: number[]) => void;
}

const SelectLocationsModal = ({
  isOpen,
  locations,
  initialSelectedIDs = [],
  description = 'Please select locations where you want to save this menu.',
  onCancel,
  onSave
}: SelectLocationsModalProps) => {
  const [selectedIDs, setSelectedIDs] = useState<number[]>(initialSelectedIDs);

  // start from the initial selection every time the modal opens
  useEffect(() => {
    if (isOpen) {
      setSelectedIDs(initialSelectedIDs);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const toggleLocation = (id: number) => {
    setSelectedIDs((ids) => (ids.includes(id) ? ids.filter((_id) => _id !== id) : [...ids, id]));
  };

  return (
    <Modal className="select-locations-modal" onOverlayClicked={onCancel}>
      <div className="select-locations-modal-header">
        <h1 className="select-locations-modal-title">SELECT LOCATIONS</h1>
        <ClosePopUpIcon onIconClicked={onCancel} />
      </div>
      <p className="select-locations-modal-subtitle">{description}</p>
      <ul className="select-locations-modal-list">
        {locations.map(({ id, label }) => (
          <li key={id}>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label>
              <CheckBox
                name={`select-location-${id}`}
                checked={selectedIDs.includes(id)}
                onChange={() => toggleLocation(id)}
              />
              <span>{label}</span>
            </label>
          </li>
        ))}
      </ul>
      <div className="select-locations-modal-footer">
        <button type="button" className="select-locations-modal-cancel" onClick={onCancel}>
          CANCEL
        </button>
        <button
          type="button"
          className="select-locations-modal-save"
          disabled={selectedIDs.length === 0}
          onClick={() => onSave(selectedIDs)}
        >
          SAVE
        </button>
      </div>
    </Modal>
  );
};

export default SelectLocationsModal;
